<template>
  <v-expand-transition>     

    <v-container fluid="">
      <v-layout>
      <v-responsive id="frame-container" :aspect-ratio="16/9" v-if="app.merkato.show">
            <iframe  
                frameborder="0"
                scrolling="no" 
                id='iframe'    
                :src = app.merkato.m_url>
            </iframe>

      </v-responsive>
    </v-layout>
    </v-container>
  </v-expand-transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["app"])
  },
  beforeDestroy() {
    this.$store.state.app.merkato.show = false;
    this.$store.state.app.merkato.load = false;
    this.$store.state.app.merkato.m_url = null;
    console.log(this.$store.state.app.merkato);
  }
};
</script>

<style scoped>
#frame-container {
  overflow: hidden;
  /* max-width: 1400px; */
  /* position: absolute; */
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 25px;
  border-radius: 5px;
}

#iframe {
  position: absolute;
  width: calc(100% + 29px);
  height: calc(100% + 54px);
  left: -5px;
  top: -28px;
}
</style>

